import { CompileSummaryKind } from '@angular/compiler';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { count } from 'console';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { RolService } from 'src/app/services/rol.service';

@Component({
  selector: 'select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss'],
})
export class SelectFilterComponent implements OnInit {
  @Output() check = new EventEmitter();
  constructor(
    private route: Router,
    private router: ActivatedRoute,
    public _casos: CasoTareaService,
    private rolService: RolService
  ) {
    this.permisosStr = this.rolService.permisos.toString();
    this.analista =
      this.permisosStr.includes('Analista de Casos Asuntos Internos') ||
      this.permisosStr.includes('Analista de Casos Asuntos Externos') ||
      this.permisosStr.includes('Analista de Casos Inteligencia') ||
      this.permisosStr.includes('Analista de Gestión de Fraudes') ||
      this.permisosStr.includes('Supervisor Gestión de Fraudes');
    this.gerente =
      this.permisosStr.includes('Admininistrador Casos de inteligencia') ||
      this.permisosStr.includes('Administrador Casos de Asuntos Externos') ||
      this.permisosStr.includes('Administrador Casos de Asuntos Internos') ||
      this.permisosStr.includes('Gerente Gestión de Fraudes');

    this.route.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        //do something on end activity
        this.actualUnidad = this.tiposCasoXUnidades.filter((unidad: any) => {
          return unidad.name == this.router.snapshot.paramMap.get('case');
        });
        this.check.emit(this.actualUnidad[0].tipo_caso);
      }
    });
  }
  actualUnidad;
  casos;
  analista;
  permisosStr: string = null;
  gerente;
  ngOnInit(): void {
    this.resetCount();
    this.check.emit(this.actualUnidad[0].tipo_caso);
  }
  resetCount() {
    let data = {
      value: this.actualUnidad[0].tipo_caso,
      correo: sessionStorage.getItem('correo'),
      analista: this.analista,
      gerente: this.gerente,
    };
    this._casos.getbyFilter(data).subscribe((response: any) => {
      for (let ele of this.actualUnidad[0].tipo_caso) {
        for (let element of response[0]) {
          if (element.name == ele.name) {
            ele.count = element.count;
          }
        }
      }
    });
  }
  // ngOnChanges(){
  //   this._casos.getbyFilter(this.actualUnidad[0].tipo_caso).subscribe((response:any)=>{
  //     this.casos = response[0]
  //     for(let ele of this.actualUnidad[0].tipo_caso){
  //       console.log(this.casos)
  //      if(this.casos != undefined || this.casos != 0){
  //       for(let element of this.casos){
  //         if(element.name == ele.name){
  //           ele.count = element.count
  //         }
  //      }
  //       }
  //     }
  //   })

  // }
  changeCheck(value) {
    for (let element of this.actualUnidad[0].tipo_caso) {
      if (element.columna == value.columna) element.checked = !element.checked;
    }
    // this.check.emit(value.columna)
    this.check.emit(this.actualUnidad[0].tipo_caso);
    this.resetCount();
  }
  tiposCasoXUnidades = [
    {
      unidad: 'Inteligencia',
      name: 'inteligencia',
      tipo_caso: [
        {
          name: 'Retención de fondos',
          columna: 'retencion',
          checked: true,
          count: 0,
          color: '#000',
        },
        {
          name: 'Gestión de casos VIP',
          columna: 'gruposvip',
          checked: true,
          count: 0,
          color: '#0053d6',
        },
        {
          name: 'Suministro de información',
          columna: 'suministro',
          checked: true,
          count: 0,
          color: '#12d5ff',
        },
      ],
    },
    {
      unidad: 'Asuntos Internos',
      name: 'internos',
      tipo_caso: [
        {
          name: 'Investigación de asuntos internos',
          columna: 'investigacionAsuntos',
          checked: true,
          count: 0,
          color: '#000',
        },
        {
          name: 'Recuperación de fondos: cuenta externa',
          columna: 'recuperacionFondos',
          checked: true,
          count: 0,
          color: '#0053d6',
        },
      ],
    },
    {
      unidad: 'Asuntos Externos',
      name: 'externos',
      tipo_caso: [
        {
          name: 'Validar Documento',
          columna: 'validarDocumento',
          checked: true,
          count: 0,
          color: '#000',
        },
        {
          name: 'Autorización de transacciones',
          columna: 'autorizacionTransacciones',
          checked: true,
          count: 0,
          color: '#0053d6',
        },
        {
          name: 'Validación de referencias',
          columna: 'validacionReferencias',
          checked: true,
          count: 0,
          color: '#12d5ff',
        },
        {
          name: 'Rol de Guardia',
          columna: 'RolGuardia',
          checked: true,
          count: 0,
          color: '#3498DB',
        },
        {
          name: 'Investigación Pre Empleo',
          columna: 'InvestigaciónEmpleo',
          checked: true,
          count: 0,
          color: '#008ecc',
        },
      ],
    },
    {
      unidad: 'Gestión de Fraudes',
      name: 'fraudes',
      tipo_caso: [
        {
          name: 'Detección y Análisis de Fraudes',
          columna: 'detecFraude',
          checked: true,
          count: 0,
          color: '#000',
        },
        {
          name: 'Determinar Recaudos de Reclamo',
          columna: 'recaudosFraude',
          checked: true,
          count: 0,
          color: '#0053d6',
        },
        {
          name: 'Gestión Administrativa de Fraudes',
          columna: 'gestionFraude',
          checked: true,
          count: 0,
          color: '#12d5ff',
        },
      ],
    },
    {
      unidad: 'Reporte de actividad sospechosa',
      name: 'ras',
      tipo_caso: [
        {
          name: 'RAS',
          columna: 'analisisRas',
          checked: true,
          count: 0,
          color: '#000',
        },
      ],
    },
  ];
}
